<template>
    <div class="card-container" v-once>
        <picture>
            <source
                srcset="
                    /images/events/2025/may-used/results/fake-card-top@1x.webp?v=2 1x,
                    /images/events/2025/may-used/results/fake-card-top@2x.webp?v=2 2x
                "
                type="image/webp"
            />
            <img
                class="fake-card__top img-responsive"
                srcset="
                    /images/events/2025/may-used/results/fake-card-top@1x.png?v=2 1x,
                    /images/events/2025/may-used/results/fake-card-top@2x.png?v=2 2x
                "
                alt="Used Cars"
            />
        </picture>
        <div class="fake-card__center">
            <picture>
                <source
                    srcset="
                        /images/events/2025/april-used/results/fake-card-center@1x.webp?v=2 1x,
                        /images/events/2025/april-used/results/fake-card-center@2x.webp?v=2 2x
                    "
                    type="image/webp"
                />
                <img
                    class="fake-card__center-img img-responsive"
                    srcset="
                        /images/events/2025/april-used/results/fake-card-center@1x.png?v=2 1x,
                        /images/events/2025/april-used/results/fake-card-center@2x.png?v=2 2x
                    "
                    alt="Used Cars"
                />
            </picture>
        </div>
        <div class="fake-card__bottom">
            <picture>
                <source
                    srcset="
                        /images/events/2025/june-battle/results/fake-card-bottom@1x.webp?v=2 1x,
                        /images/events/2025/june-battle/results/fake-card-bottom@2x.webp?v=2 2x
                    "
                    type="image/webp"
                />
                <img
                    class="fake-card__bottom-img img-responsive"
                    srcset="
                        /images/events/2025/june-battle/results/fake-card-bottom@1x.png?v=2 1x,
                        /images/events/2025/june-battle/results/fake-card-bottom@2x.png?v=2 2x
                    "
                    alt="Used Cars"
                />
            </picture>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.fake-card {
    &__top {
        transform: translateY(-5px);
    }

    &__center {
        position: absolute;
        top: 54%;
        transform: translateY(-50%);
        left: 0;
        width: 100%;
        text-align: center;
    }

    &__center-img {
        margin: 0 auto;
    }

    &__bottom {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        flex-grow: 1;
        padding-bottom: 40px;
    }

    &__bottom-img {
        max-height: 150px;
    }

    &__terms {
        text-align: center;
        color: white;
        font-size: 13px;
    }
}

.card-container {
    box-shadow: 0 11px 24px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    width: 100%;
    height: 100%;
    min-height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #003c38;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    padding: 0 30px 10px 30px;

    .no-webp & {
        background-image: url('/images/events/2025/april-used/results/fake-card-bg@1x.jpg');
    }

    .webp & {
        background-image: url('/images/events/2025/april-used/results/fake-card-bg@1x.webp');
    }

    @media only screen and (-webkit-min-device-pixel-ratio: 2),
        only screen and (min--moz-device-pixel-ratio: 2),
        only screen and (min-device-pixel-ratio: 2),
        only screen and (min-resolution: 192dpi),
        only screen and (min-resolution: 2dppx) {
        .no-webp & {
            background-image: url('/images/events/2025/april-used/results/fake-card-bg@2x.jpg');
        }

        .webp & {
            background-image: url('/images/events/2025/april-used/results/fake-card-bg@2x.webp');
        }
    }

    @media screen and (max-width: 991px) {
        min-height: 670px;
    }

    @media screen and (max-width: 767px) {
        min-height: 650px;
    }

    @media screen and (max-width: 600px) {
        min-height: 590px;
    }

    @media screen and (max-width: 500px) {
        min-height: 560px;
    }

    @media screen and (max-width: 400px) {
        min-height: 520px;
    }

    @media screen and (max-width: 300px) {
        min-height: 460px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Campaign/2025/April/FakeCard.vue